import type { CmsProduct } from '../../types/cmsProduct';
import { getFulfilmentPath } from '../../utils/tiAttributes';
import { tr } from '../../utils/translations/tr';
import type { CompareCtaTone } from './types';

/**
 * How a plan checks out, as the comparison page reads it: a click-out to the insurer, or an
 * end-to-end checkout here. A product with no recognised path is read as end to end, as the results
 * card reads it. The label and the colour both come from this, so they cannot disagree.
 */
const checksOutHere = (product: CmsProduct | undefined): boolean =>
  getFulfilmentPath(product) !== 'click_out';

/** "Apply Now" for an end-to-end checkout, "Buy Now" for a click-out, in both markets. */
export function compareCtaLabel(
  product: CmsProduct | undefined,
  staticText: Record<string, string>,
): string {
  return checksOutHere(product)
    ? tr('compare_cta_e2e', staticText)
    : tr('compare_cta_clickout', staticText);
}

/** The design's colour for that checkout: the orange call to action, or the blue plain button. */
export function compareCtaTone(
  product: CmsProduct | undefined,
): CompareCtaTone {
  return checksOutHere(product) ? 'cta' : 'primary';
}
